import React from 'react';
import { Link } from 'react-router-dom';
import { IconContext } from 'react-icons';
import {
    BsLayoutSidebarInset,
    BsLayoutSidebarInsetReverse,
} from 'react-icons/bs';

import { nav } from '../utils/utils';

const Sidebar = () => {
    const [active, setActive] = React.useState(false);
    return (
        <div className='z-10 flex flex-wrap content-start fixed right-0 text-white'>
            <button className='self-start' onClick={() => setActive(!active)}>
                <IconContext.Provider
                    value={{
                        color: 'silver',
                        className: 'my-auto w-8 h-8 ',
                    }}
                >
                    {active ? (
                        <BsLayoutSidebarInset />
                    ) : (
                        <BsLayoutSidebarInsetReverse />
                    )}
                </IconContext.Provider>
            </button>
            {active && (
                <div className='block w-52 h-screen backdrop-blur bg-white/20'>
                    <h1 className='mt-4 font-bold text-2xl text-center'>
                        Jump to
                    </h1>
                    <ul className='text-center'>
                        {nav.map((item, idx) => {
                            return (
                                <li className='group m-2 px-8 py-1' key={idx}>
                                    <Link to={item.to} className='ml-2 '>
                                        {item.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default Sidebar;
